import React, { useEffect, useState } from "react";

//redux
import { connect, useDispatch, useSelector } from "react-redux";

//MUI
import {
    Dialog,
    DialogContent,
    DialogTitle,
    IconButton,
    Tooltip,
} from "@material-ui/core";
import { Cancel } from "@material-ui/icons";

//types
import { CLOSE_ADMIN_DIALOG } from "../../store/adminManagement/types";

//action
import { createAdmin, updateAdmin } from "../../store/adminManagement/action";

import { permissionError } from "../../util/Alert";
import TemporaryPassword from "../TemporaryPassword";

const AdminDialog = (props) => {
    const dispatch = useDispatch();

    const { dialog: open, dialogData } = useSelector((state) => state.adminManagement);
    const hasPermission = useSelector((state) => state.admin.admin.flag);

    const [name, setName] = useState("");
    const [email, setEmail] = useState("");
    const [username, setUsername] = useState("");
    const [created, setCreated] = useState(null);
    const [flag, setFlag] = useState(false);

    const [errors, setError] = useState({
        name: "",
        email: "",
    });

    const isEditing = dialogData !== null;

    useEffect(() => {
        if (dialogData) {
            setName(dialogData.name || "");
            setEmail(dialogData.email || "");
            setFlag(dialogData.flag || false);
        }
    }, [dialogData]);

    useEffect(
        () => () => {
            setError({
                name: "",
                email: "",
            });
            setName("");
            setEmail("");
            setUsername("");
            setCreated(null);
            setFlag(false);
        },
        [open]
    );

    const closePopup = () => {
        dispatch({ type: CLOSE_ADMIN_DIALOG });
    };

    const handleSubmit = (e) => {
        e.preventDefault();

        const error = {};
        if (!name) error.name = "Name is required!";
        if (!isEditing && !username.trim()) error.username = "Username is required!";

        if (Object.keys(error).length > 0) {
            return setError({ ...error });
        }

        // Email is optional; it is only used for Lark notifications.
        const emailRegex = /^[^\s@]+@[^\s@]+\.[^\s@]+$/;
        if (email && !emailRegex.test(email)) {
            return setError({ ...errors, email: "Invalid email format!" });
        }

        if (!hasPermission) return permissionError();

        if (isEditing) {
            const data = {
                name: name.trim(),
                email: email.trim(),
                flag: flag,
            };
            props.updateAdmin(dialogData._id, data);
        } else {
            const data = {
                name: name.trim(),
                email: email.trim(),
                username: username.trim(),
            };
            props.createAdmin(data).then((result) => {
                if (result) setCreated(result);
            });
        }
    };

    return (
        <>
            <Dialog
                open={open}
                aria-labelledby="responsive-dialog-title"
                onClose={closePopup}
                disableBackdropClick
                disableEscapeKeyDown
                fullWidth
                maxWidth="sm"
            >
                <DialogTitle id="responsive-dialog-title">
                    <span className="text-danger font-weight-bold h4">
                        {created ? "Admin created" : isEditing ? "Edit Admin" : "Create Admin"}
                    </span>
                </DialogTitle>

                <IconButton
                    style={{
                        position: "absolute",
                        right: 0,
                    }}
                >
                    <Tooltip title="Close">
                        <Cancel className="text-danger" onClick={closePopup} />
                    </Tooltip>
                </IconButton>
                <DialogContent>
                    <div className="modal-body pt-1 px-1 pb-3">
                        {created ? (
                            <div>
                                <TemporaryPassword {...created} />
                                <div className="mt-4">
                                    <button
                                        type="button"
                                        className="btn btn-round float__right btn-danger"
                                        onClick={closePopup}
                                    >
                                        Done
                                    </button>
                                </div>
                            </div>
                        ) : (
                        <div className="d-flex flex-column">
                            <form>
                                {!isEditing && (
                                    <div className="form-group mb-3">
                                        <label className="mb-2 text-gray">Username</label>
                                        <input
                                            type="text"
                                            className="form-control"
                                            value={username}
                                            placeholder="Used to sign in"
                                            autoComplete="off"
                                            onChange={(e) => {
                                                setUsername(e.target.value);
                                                setError({ ...errors, username: "" });
                                            }}
                                        />
                                        {errors.username && (
                                            <div className="ml-2 mt-1">
                                                <div className="pl-1 text__left">
                                                    <span className="text-red">{errors.username}</span>
                                                </div>
                                            </div>
                                        )}
                                    </div>
                                )}
                                <div className="form-group">
                                    <label className="mb-2 text-gray">Name</label>
                                    <input
                                        type="text"
                                        className="form-control"
                                        required=""
                                        value={name}
                                        placeholder="Enter admin name"
                                        onChange={(e) => {
                                            setName(e.target.value);
                                            if (!e.target.value) {
                                                return setError({
                                                    ...errors,
                                                    name: "Name is Required!",
                                                });
                                            } else {
                                                return setError({
                                                    ...errors,
                                                    name: "",
                                                });
                                            }
                                        }}
                                    />
                                    {errors.name && (
                                        <div className="ml-2 mt-1">
                                            <div className="pl-1 text__left">
                                                <span className="text-red">{errors.name}</span>
                                            </div>
                                        </div>
                                    )}
                                </div>
                                <div className="form-group mt-3">
                                    <label className="mb-2 text-gray">Email</label>
                                    <input
                                        type="email"
                                        className="form-control"
                                        required=""
                                        value={email}
                                        placeholder="Optional, for Lark notifications"
                                        onChange={(e) => {
                                            setEmail(e.target.value);
                                            setError({ ...errors, email: "" });
                                        }}
                                    />
                                    {errors.email && (
                                        <div className="ml-2 mt-1">
                                            <div className="pl-1 text__left">
                                                <span className="text-red">{errors.email}</span>
                                            </div>
                                        </div>
                                    )}
                                </div>
                                <div className="mt-5">
                                    <button
                                        type="button"
                                        className="btn btn-outline-info ml-2 btn-round float__right icon_margin"
                                        onClick={closePopup}
                                    >
                                        Close
                                    </button>
                                    <button
                                        type="button"
                                        className="btn btn-round float__right btn-danger"
                                        onClick={handleSubmit}
                                    >
                                        {isEditing ? "Update" : "Submit"}
                                    </button>
                                </div>
                            </form>
                        </div>
                        )}
                    </div>
                </DialogContent>
            </Dialog>
        </>
    );
};

export default connect(null, { createAdmin, updateAdmin })(AdminDialog);
